module.exports = __webpack_public_path__ + "assets/img/carousel_6.104b0256.png";